module.exports = __webpack_public_path__ + "static/img/haitang_icon.fdcfa06.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/haitang_icon.png
// module id = 0nOh
// module chunks = 1